import * as React from 'react';
import { Icon } from '../../Icon';
import { IIcon } from '../../../interfaces/IIcon';

export function CalendarIcon(props: IIcon) {
    const newViewProps = '0 0 16 16' ?? props.viewBox;
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={newViewProps}
            style={props.style}
            className={props.className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.80034 0.799731C4.80034 0.357887 4.44215 -0.000305176 4.0003 -0.000305176C3.55846 -0.000305176 3.20027 0.357887 3.20027 0.799731V1.59977H2.40023C1.07469 1.59977 0.00012207 2.67434 0.00012207 3.99988V13.6003C0.00012207 14.9259 1.07469 16.0004 2.40023 16.0004H13.6007C14.9263 16.0004 16.0008 14.9259 16.0008 13.6003V3.99988C16.0008 2.67434 14.9263 1.59977 13.6007 1.59977H12.8007V0.799731C12.8007 0.357887 12.4425 -0.000305176 12.0007 -0.000305176C11.5588 -0.000305176 11.2006 0.357887 11.2006 0.799731V1.59977H4.80034V0.799731ZM1.60019 6.39999V13.6003C1.60019 14.0422 1.95839 14.4004 2.40023 14.4004H13.6007C14.0426 14.4004 14.4008 14.0422 14.4008 13.6003V6.39999H1.60019ZM3.2003 8.80009C3.2003 8.35823 3.55849 8.00006 4.00034 8.00006H5.60041C6.04225 8.00006 6.40044 8.35823 6.40044 8.80009V10.4002C6.40044 10.842 6.04225 11.2002 5.60041 11.2002H4.00034C3.55849 11.2002 3.2003 10.842 3.2003 10.4002V8.80009Z"
            />
        </Icon>
    );
}
